module.exports = __webpack_public_path__ + "img/addBankSucceed.06dd8ff7.png";